// src/themes/themes.ts
import { Theme } from '../types/theme'

export const themes: Record<string, Theme> = {
  light: {
    name: 'Light',
    colors: {
      primary: '#3a667a',
      secondary: '#8cc780',
      tertiary: '#6aaaec',
      quaternary: '#e7af65',
      background: '#e8f0f2',
      surface: '#ffffff',
      shell: '#fef5ec',
      gradientFrom: '#fef5ec',
      gradientTo: '#91c2be',
      text: '#2c3e50',
      textSecondary: '#64748b',
      border: '#d4e4e8',
      success: '#5fca8a',
      warning: '#f0a857',
      error: '#f4a091',
      info: '#1e7b9e'
    },
    spacing: {
      xs: '0.25rem',
      sm: '0.5rem',
      md: '1rem',
      lg: '1.5rem',
      xl: '2rem'
    },
    typography: {
      fontFamily: "'Roboto', 'Open Sans', sans-serif",
      fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem'
      }
    },
    borderRadius: {
      sm: '0.25rem',
      md: '0.5rem',
      lg: '0.75rem'
    },
    shadows: {
      sm: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
      md: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
      lg: '0 10px 15px -3px rgb(0 0 0 / 0.1)'
    }
  },

  dark: {
    name: 'Dark',
    colors: {
      primary: '#60a5fa',
      secondary: '#94a3b8',
      tertiary: '#93c5fd',
      quaternary: '#fbbf24',
      background: '#0f172a',
      surface: '#1e293b',
      shell: '#1e293b',
      gradientFrom: '#0f172a',
      gradientTo: '#1e293b',
      text: '#f1f5f9',
      textSecondary: '#94a3b8',
      border: '#334155',
      success: '#34d399',
      warning: '#fbbf24',
      error: '#f87171',
      info: '#22d3ee'
    },
    spacing: {
      xs: '0.25rem',
      sm: '0.5rem',
      md: '1rem',
      lg: '1.5rem',
      xl: '2rem'
    },
    typography: {
      fontFamily: "'Roboto', 'Open Sans', sans-serif",
      fontSize: {
        xs: '0.75rem',
        sm: '0.875rem',
        md: '1rem',
        lg: '1.125rem',
        xl: '1.25rem'
      }
    },
    borderRadius: {
      sm: '0.25rem',
      md: '0.5rem',
      lg: '0.75rem'
    },
    shadows: {
      sm: '0 1px 2px 0 rgb(0 0 0 / 0.3)',
      md: '0 4px 6px -1px rgb(0 0 0 / 0.4)',
      lg: '0 10px 15px -3px rgb(0 0 0 / 0.4)'
    }
  },

}